export const PLAYER_STATE_EVENTS = {
  READY: 'ready',
  PLAYING: 'playing',
  SKIPPED: 'skipped',
  MUTED: 'muted',
  COMPLETED: 'completed',
};
